import { render } from "./Entete.vue?vue&type=template&id=062a7838"
import script from "./Entete.vue?vue&type=script&lang=js"
export * from "./Entete.vue?vue&type=script&lang=js"

import "./Entete.vue?vue&type=style&index=0&id=062a7838&lang=css"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__